import client from './client'
import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

export default {
  // ログイン
  login: param => {
    return new Promise((resolve, reject) => {

      var url = '/Token'
      var qs = require('qs')

      //  usernameはOAuthの仕様
      var data = qs.stringify({
        'grant_type': 'password',
        'username': param.userId,
        'password': param.password
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data
      }

      client(config)
        .then(responce => {
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  // ログアウト
  logout: token => {
    return new Promise((resolve, reject) => {

      var url = '/api/Account/Logout'

      var qs = require('qs')

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js